import { createFileRoute } from "@tanstack/react-router"
import { ImageResizerScreenWrapper } from "./-ImageResizerPage"

export const Route = createFileRoute("/tools/image-resizer")({
  component: ImageResizerScreenWrapper,
})
